import React from 'react';
import { Link } from 'react-router-dom';
import { Scale } from 'lucide-react';

const Header: React.FC = () => {
  return (
    <header className="backdrop-blur-xl bg-white/40 border-b border-white/20 sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center gap-2 text-sky-500 text-xl">
          <Scale size={24} strokeWidth={1.5} />
          <span className="font-light">Czen.fr</span>
        </Link>
        <nav className="flex gap-6">
          <Link 
            to="/" 
            className="text-slate-600 hover:text-sky-500 transition-colors font-light"
          >
            Accueil
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;